import AuthContext from "../store/AuthContext";
import { useContext } from "react";

export default function NotFound() {
  const { loggedPerson } = useContext(AuthContext);

  return (
    <div className={`${loggedPerson && "ml-10 md:ml-20"}`}>
      <div className="relative h-[65vh] text-left px-4 py-7 items-start flex flex-col gap-[1.5rem] md:py-8 md:px-6 lg:py-10 lg:px-10 lg:gap-[2.5rem]">
        <div className="flex w-full gap-10">
          <h1 className="mb-3 text-white font-medium text-left text-[40px] sm:text-[48px] lg:text-[50px] xl:text-[56px] 2xl:text-[62px] flex-shrink-0 pr-8">
            Error
          </h1>
          <div className="flex-1 h-[60px] bg-[url(./assets/images&icons/banner-pattern.png)] bg-contain bg-repeat-x bg-right-center pointer-events-none" />
        </div>
        <div className="w-full h-[50vh] flex bg-white p-7">
          <div className="flex flex-col w-full h-full bg-gray-100 rounded-lg justify-center items-center text-center p-10">
            <div className="flex text-primary font-bold text-2xl">
              404 File Not Found
            </div>
            <div className="flex text-font-gray text-sm">
              The file/page you are looking for does not exist.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
